import { useNavigate } from 'react-router-dom';
import { useFilamentos } from '@/hooks/useInsumos';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';
import { Badge } from '@/components/ui/Badge';
import { ArrowLeft, Package, AlertTriangle } from 'lucide-react';
import { formatWeight } from '@/lib/utils';
import type { Filamento } from '@/types';

export function Estoque() {
  const navigate = useNavigate();
  const { data: filamentos, isLoading } = useFilamentos();

  return (
    <div className="min-h-screen bg-fort3d-preto p-4">
      <div className="max-w-md mx-auto">
        {/* Header */}
        <div className="flex items-center gap-4 mb-6 pt-4">
          <button onClick={() => navigate('/modo-fabrica')} className="text-white">
            <ArrowLeft className="h-6 w-6" />
          </button>
          <h1 className="text-2xl font-bold text-white">Estoque</h1>
        </div>

        {/* Resumo */}
        <Card className="mb-6">
          <CardContent className="p-6">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-full bg-fort3d-verde/10 flex items-center justify-center">
                <Package className="h-7 w-7 text-fort3d-verde" />
              </div>
              <div>
                <p className="text-fort3d-cinza-claro text-sm">Total em Estoque</p>
                <p className="text-2xl font-bold text-white">
                  {isLoading ? '...' : formatWeight(
                    filamentos?.reduce((sum: number, f: Filamento) => sum + f.pesoAtualGramas, 0) || 0
                  )}
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Lista de Filamentos */}
        <Card>
          <CardHeader>
            <CardTitle className="text-lg">Filamentos</CardTitle>
          </CardHeader>
          <CardContent>
            {isLoading ? (
              <div className="text-center py-8 text-fort3d-cinza-claro">Carregando...</div>
            ) : (
              <div className="space-y-3">
                {filamentos?.map((filamento: Filamento) => (
                  <div
                    key={filamento.id}
                    className="flex items-center justify-between p-4 rounded-xl bg-fort3d-cinza-escuro"
                  >
                    <div className="flex items-center gap-3">
                      <div
                        className="w-4 h-4 rounded-full border-2 border-white/20"
                        style={{
                          backgroundColor: filamento.cor.toLowerCase(),
                          boxShadow: `0 0 10px ${filamento.cor.toLowerCase()}40`,
                        }}
                      />
                      <div>
                        <p className="text-white font-medium">
                          {filamento.material} {filamento.cor}
                        </p>
                        <p className="text-xs text-fort3d-cinza-claro">{filamento.fabricante}</p>
                      </div>
                    </div>
                    <div className="text-right">
                      <p
                        className={`font-mono font-medium ${
                          filamento.pesoAtualGramas < 500 ? 'text-fort3d-vermelho' : 'text-white'
                        }`}
                      >
                        {formatWeight(filamento.pesoAtualGramas)}
                      </p>
                      {filamento.pesoAtualGramas < 500 && (
                        <Badge variant="error" className="text-xs">
                          <AlertTriangle className="h-3 w-3 mr-1" />
                          Baixo
                        </Badge>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
